import axios from 'axios'

const baseUrl = process.env.REACT_APP_API_URL;
const creatingTaxes = async (dataa) => {
  const inclusiveValue = dataa?.inclusive === 'Inclusive'
  const data = {
    display_name: dataa?.name,
    description: dataa?.description,
    jurisdiction: dataa?.jurisdiction,
    tax_type: dataa?.percentage,
    inclusive: inclusiveValue,
    country: dataa?.country,
    billing_info: dataa?.billingInfo,
    percentage: dataa?.percent,
  }
  const path = '/api/user/createTaxRate'
  const url = baseUrl + path
  const response = await axios.post(url, data)
  return response.data
}

// __________get taxes rates ___________

const getAllTaxRate = async (page) => {
  const path = `/api/user/getAllTaxRate/${page}`
  const url = baseUrl + path
  const response = await axios.get(url)
  return response?.data
}

// _________delete tax _________
const deleteTaxRate = async (id) => {
  const path = `/api/user/deleteDBTaxes/${id}`
  const url = baseUrl + path
  const response = await axios.delete(url)
  return response.data
}

// _________change status tax _________
const changeTaxStatus = async (data) => {
  const path = `/api/user/changeTaxeStatus/${data?.id}`
  data = {
    status: data.status,
  }
  const url = baseUrl + path
  const response = await axios.post(url, data)
  return response.data
}

const taxesService = {
  creatingTaxes,
  getAllTaxRate,
  deleteTaxRate,
  changeTaxStatus,
}

export default taxesService
